<template>
  <TooltipProvider :delay-duration="200">
    <TooltipRoot>
      <TooltipTrigger as-child>
        <slot name="trigger" />
      </TooltipTrigger>

      <TooltipPortal to="body">
        <TooltipContent class="tooltip show" avoid-collisions>
          <div :class="contentClass">
            <slot />
          </div>
          <TooltipArrow />
        </TooltipContent>
      </TooltipPortal>
    </TooltipRoot>
  </TooltipProvider>
</template>

<script setup>
import {
  TooltipArrow,
  TooltipContent,
  TooltipPortal,
  TooltipProvider,
  TooltipRoot,
  TooltipTrigger,
} from 'radix-vue'
import { computed } from 'vue'

/* eslint-disable vue/require-default-prop */
const props = defineProps({
  class: {
    type: String,
    required: false,
  },
})

const contentClass = computed(() => ['tooltip-inner', props.class])
</script>
